const API_URL_V2 = "https://backend.pochete.app/api/auth";
// const API_URL_V2 = "http://localhost:3000/api/auth";

export interface LoginResponse {
  body: UserData;
  status: number;
}

export interface UserData {
  id?: string;
  email?: string;
  token?: string;
  error?: string;
}

export const authApiV2 = {
  login: async (email: string, pw: string): Promise<LoginResponse> => {
    const response = await fetch(`${API_URL_V2}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, pw }),
    });

    const data = await response.json();

    if (response.status === 200) {
      await authApiV2.setUser(data);
    }

    return {
      body: data,
      status: response.status,
    };
  },

  setUser: async (userData: UserData): Promise<void> => {
    localStorage.setItem("user", JSON.stringify(userData));
  },

  getUser: (): UserData => {
    const user = localStorage.getItem("user");
    if (user) {
      return JSON.parse(user) as UserData;
    }
  },

  logout: async (): Promise<void> => {
    localStorage.removeItem("user");
  },
};
